export default "/static/webpack/images/base/verified.svg";